/** @jsxImportSource @emotion/react */
"use client";

import Image from "next/image";
import Grid from "@mui/material/Grid";
import Typography from "@mui/material/Typography";

import { imageStyles } from "./style";

interface InfoSectionProps {
  title: string;
  text: string;
  imageUrl: string;
  reverse?: boolean;
}

export default function InfoSection({
  title,
  text,
  imageUrl,
  reverse = false,
}: InfoSectionProps) {
  return (
    <Grid
      container
      spacing={4}
      alignItems="center"
      justifyContent="space-between"
      my={{ md: 8, xs: 3 }}
    >
      <Grid size={{ xs: 12, md: 6 }} order={{ xs: 1, md: reverse ? 2 : 1 }}>
        <Image
          src={imageUrl}
          alt={title}
          width={500}
          height={400}
          priority
          css={imageStyles}
        />
      </Grid>
      <Grid size={{ xs: 12, md: 6 }} order={{ xs: 2, md: reverse ? 1 : 2 }}>
        <Typography variant="h2" mb={4}>
          {title}
        </Typography>
        {text.split("\n").map((line, index) => (
          <Typography key={index} variant="body1">
            <span>{line} </span>
            <br />
          </Typography>
        ))}
      </Grid>
    </Grid>
  );
}
